module.exports = __webpack_public_path__ + "img/ai_audio_text_playing.ad6174d.png";